import { sendRequest } from "./api";
import { IGoal } from "../types/dashboard";
import { getAuth } from "@firebase/auth";
import { Environment } from '../utils/environment';

const route = 'goal';

let url: string;
if (Environment.isProduction()) {
    url = 'https://solaris-backend-development.replit.app/';    
} else {
    url = "https://a5d105b2-054e-4f6d-a7c2-5b0f27f4046e-00-33bmfpe9h80v4.riker.repl.co/";
}

export const getClientGoals = async (clientId: string): Promise<IGoal[]> => {
    const response = await sendRequest(route + '/', 'GET', undefined, clientId);
    
    if (!response) {
        return [];
    }
    
    const data = await response.json();
    
    if (!Array.isArray(data)) {
        return [];
    }
    
    const transformedGoals: IGoal[] = data.map((item: any) => {
        const goalId = Object.keys(item)[0];
        const goalData = item[goalId];
        return {
            id: goalId,
            ...goalData
        };
    });
    
    return transformedGoals;
}

export const createGoal = (goal: IGoal) => {
    return sendRequest(route, 'POST', goal, '');
}

export const updateGoal = (goalId: string, goal: Partial<IGoal>) => {
    return sendRequest(route + '/single/', 'PUT', goal, goalId);
}

export const updateGoalKeepAlive = async (goalId: string, goal: Partial<IGoal>) => {
    const auth = getAuth();
    if (!auth.currentUser) return;
    
    try {
        const token = await auth.currentUser.getIdToken();
        fetch(url + route + '/single/' + goalId, {
            method: 'PUT',
            body: JSON.stringify(goal),
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${token}`
            },
            keepalive: true
        });
    } catch (err) {
        console.error('Failed to send keepalive update:', err);
    }
}

export const deleteGoal = (goalId: string) => {
    return sendRequest(route + '/single/', 'DELETE', undefined, goalId);
}
